/*
    Before:
    {
      'fieldName': fieldValue
    }

    After:
    [{
      name: 'fieldName',
      data: fieldValue
    }]
*/
function mapFormData(formData) {
  const newList = [];
  Object.keys(formData).forEach(key => {
    newList.push({ name: key, data: formData[key] });
  });
  return newList;
}

export default {
  mapFormData,
};
